export const HOME_PAGE = "/";
export const PRINCING = "/pricing";
export const PRIVACY_POLICY = "/privacy-policy";
export const TERMS = "/terms-of-service";
export const DATA_DELETION_REQUEST = "/data-deletion-page";
export const BLOG = "/blog";
export const AFFILIATE = "/affiliate";
export const CONTACT_US = " /contact-us";
export const CANCELLATION_REFUND = "/legal/cancellation-refund";
export const SHIPPING_DELIVERY = "/legal/shipping-delivery";

// SOLUTION
export const SOLUTION_AD_CREATION = "/solution/ad-creation";
export const SOLUTION_CREATIVE_INTELLIGENCE = "/solution/creative-intelligence";
export const SOLUTION_TESTING_OPTIMIZATION = "/solution/testing-optimization";
export const SOLUTION_WORKSPACE_ASSETS = "/solution/workspace-assets";

// PLATFORMS

export const PLATFORM_META = "/platform/meta";
export const PLATFORM_GOOGLE = "/platform/google";
export const PLATFORM_SEO = "/platform/seo";
